import React from 'react'
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import {ReactComponent as UploadIcon} from "../../../../../resources/images/upload-icon.svg";
import styles from "./styles";

const CustomInput = (props) => {
  const {
    className,
    labelClassName,
    labelWithFilesClassName,
    style,
    labelStyle,
    labelWithFilesStyle,
    getFilesFromEvent,
    accept,
    multiple,
    disabled,
    content,
    withFilesContent,
    onFiles,
    files,
  } = props

  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <label
      className={classes.input}
      style={files.length > 0 ? labelWithFilesStyle : labelStyle}
    >
      <div className={classes.uploadIcon}>
        <UploadIcon className={classes.iconColor} />
      </div>
      <p><a><FormattedMessage id="guestDropzone.uploadLinkText"/></a> <FormattedMessage id="guestDropzone.uploadText"/></p>
      <p className={classes.csvText}><FormattedMessage id="guestDropzone.csv"/></p>
      <input
        className={className}
        style={style}
        type="file"
        accept={accept}
        multiple={multiple}
        disabled={disabled}
        onChange={async e => {
          const target = e.target
          const chosenFiles = await getFilesFromEvent(e)
          onFiles(chosenFiles)
          target.value = null
        }}
      />
    </label>
  )
}

export default CustomInput
